import { AbstractResource } from "./AbstractResource";

export class Screens extends AbstractResource {
    async getDeviceLog() {
        const { data } = await this.http.get(`/device-log`, {
            baseURL: process.env.VUE_APP_API_URL,
        });
        return data;
    }
}